export default __webpack_public_path__ + "static/media/benefit-4.079ce9fe.png";